import { FieldSchema } from "../../../Schema";
import { GridFilterTypes } from "../../../grid/AgGridManager";
import { getGroupValues } from "../external-sources/GroupMasters";
import { SchemaContext } from "../../common";

export const createBelongingToGroup = (context: SchemaContext): FieldSchema => ({
  grid: {
    displayed: true,
    order: 14,
    filter: GridFilterTypes.SET,
    // Filtered as a set, but free text on the form — so the options belong to the grid
    // rather than to `data`, where they would turn this into an enum the form must match.
    filterValues: { getter: () => getGroupValues(context.client) },
  },
  name: "belongingToGroup",
  display: {
    displayed: true,
  },
  validation: { required: true },
  form: { label: "Group" },
});
